import _globalThis2 from "../internals/global-this";
var exports = {};
var _globalThis = _globalThis2;
exports = _globalThis;
export default exports;